module.exports = __webpack_public_path__ + "static/fonts/iconfont.2788b4c1.ttf";